module.exports = __webpack_public_path__ + "img/14.da95705c.png";